import React, { useRef, useState } from 'react'
import { ExternalLinkIcon } from '../icons/externalLinkIcon'

function Accordion({
  headline,
  children,
  secondaryHeadline,
  secondaryText,
  btnLabel,
  btnAction,
}: {
  headline: string
  secondaryHeadline?: string
  secondaryText?: string
  btnLabel?: string
  btnAction?: () => void
  children: React.ReactNode
}) {
  const [active, setActive] = useState(false)
  const content = useRef<HTMLInputElement>(null)
  const [height, setHeight] = useState('0px')

  function toggleAccordion() {
    setActive(!active)
    if (content.current) {
      setHeight(active ? '0px' : `${content.current.scrollHeight}px`)
    }
  }

  return (
    <div className="flex flex-col">
      <div
        className="bg-white cursor-pointer border-b-1  grid grid-cols-1 justify-between relative border-t-1 border-separators-grey  py-6 px-4 hover:bg-engineering-grey-4
        md:px-6  md:grid-cols-[0.7fr,1fr] md:items-top  md:gap-0
        xl:px-10 xl:grid-cols-2
        "
        onClick={toggleAccordion}
      >
        <div className="flex items-center">
          <h3 className=" pr-[64px] md:pr-0 pb-6 md:pb-0">{headline}</h3>
        </div>
        <div className="flex flex-row items-top md:h-min md:justify-end  ">
          <div
            className="flex flex-col gap-6 justify-between
        md:flex-row md:px-[70px] md:w-full
        xl:px-[120px]
        "
          >
            <div className="flex flex-col ">
              {secondaryHeadline && <span>{secondaryHeadline}</span>}
              {secondaryText && (
                <span className="md:w-[150px]">
                  <b>{secondaryText}</b>
                </span>
              )}
            </div>
            {btnLabel && (
              <div className=" shrink-0">
                <button
                  className="btn btn-secondary flex gap-[10px]"
                  onClick={() => {
                    btnAction && btnAction()
                  }}
                >
                  <span>{btnLabel} </span>
                  <div>
                    <ExternalLinkIcon />
                  </div>
                </button>
              </div>
            )}
          </div>

          <div className="md:relative md:isolate flex items-start h-fit">
            <button
              className={`btn btn-circle-small absolute  top-6 right-4 btn-accordion pointer-events-none ${
                active && 'rotate-45'
              } transition-all duration-300
              md:static
              `}
            ></button>
          </div>
        </div>
      </div>
      <div
        ref={content}
        style={{ maxHeight: `${height}` }}
        className="bg-white overflow-hidden transition-all duration-300 "
      >
        {children}
      </div>
    </div>
  )
}

export default Accordion
